var map = {
	"./flags/en.svg": 1023,
	"./flags/es.svg": 1024,
	"./flags/fr.svg": 1025,
	"./flags/it.svg": 1026,
	"./flags/nl.svg": 1027,
	"./flags/pt.svg": 1028,
	"./icons/icon-arrow-up.svg": 1029,
	"./icons/icon-beach--green.svg": 1030,
	"./icons/icon-beach--red.svg": 1031,
	"./icons/icon-beach.svg": 1032,
	"./icons/icon-bell.svg": 1033,
	"./icons/icon-break.svg": 1034,
	"./icons/icon-caret-down-bold.svg": 1035,
	"./icons/icon-caret-down.svg": 1036,
	"./icons/icon-caret-left--white.svg": 1037,
	"./icons/icon-caret-right-bold.svg": 1038,
	"./icons/icon-chevron-circle-left--white.svg": 1039,
	"./icons/icon-chevron-circle-left.svg": 1040,
	"./icons/icon-chevron-circle-right--white.svg": 1041,
	"./icons/icon-chevron-circle-right.svg": 1042,
	"./icons/icon-chevron-down.svg": 158,
	"./icons/icon-chevron-up.svg": 159,
	"./icons/icon-close.svg": 1043,
	"./icons/icon-dropdown.svg": 1044,
	"./icons/icon-email.svg": 1045,
	"./icons/icon-heart-fill.svg": 1046,
	"./icons/icon-heart-outline.svg": 1047,
	"./icons/icon-heart-red.svg": 1048,
	"./icons/icon-info--circle.svg": 1049,
	"./icons/icon-legend-buoys.svg": 1050,
	"./icons/icon-legend-star.svg": 1051,
	"./icons/icon-legend-swell-arrow.svg": 1052,
	"./icons/icon-legend-swell.svg": 1053,
	"./icons/icon-legend-wind.svg": 1054,
	"./icons/icon-live.svg": 1055,
	"./icons/icon-loader.svg": 1056,
	"./icons/icon-plus.svg": 1057,
	"./icons/icon-point--green.svg": 1058,
	"./icons/icon-point--red.svg": 1059,
	"./icons/icon-point.svg": 1060,
	"./icons/icon-print.svg": 1061,
	"./icons/icon-reef--green.svg": 1062,
	"./icons/icon-reef--red.svg": 1063,
	"./icons/icon-reef.svg": 1064,
	"./icons/icon-resort.svg": 1065,
	"./icons/icon-river--green.svg": 1066,
	"./icons/icon-river--red.svg": 1067,
	"./icons/icon-river.svg": 1068,
	"./icons/icon-sandbar--green.svg": 1069,
	"./icons/icon-sandbar--red.svg": 1070,
	"./icons/icon-sandbar.svg": 1071,
	"./icons/icon-search--bold.svg": 1072,
	"./icons/icon-search.svg": 1073,
	"./icons/icon-share.svg": 1074,
	"./icons/icon-thumbs-down-solid.svg": 1075,
	"./icons/icon-thumbs-up-solid.svg": 1076,
	"./icons/icon-tidal-range--blue.svg": 1077,
	"./icons/icon-tide-clock--color.svg": 1078,
	"./icons/icon-tide-needle.svg": 1079,
	"./icons/icon-tide-star.svg": 1080,
	"./icons/icon-user.svg": 1081,
	"./logos/apple-logo--black.svg": 96,
	"./logos/apple-logo--white.svg": 1082,
	"./logos/google-g-logo.svg": 97,
	"./logos/icon-facebook.svg": 1083,
	"./logos/icon-linkedin.svg": 1084,
	"./logos/icon-reddit.svg": 1085,
	"./logos/icon-telegram.svg": 1086,
	"./logos/icon-whatsapp.svg": 1087,
	"./logos/icon-x.svg": 1088,
	"./logos/outside-logo--black.svg": 1089,
	"./logos/outside-logo--white.svg": 1090,
	"./logos/surf-forecast__icon--white.svg": 1091,
	"./logos/surf-forecast__logo--black.svg": 1092,
	"./logos/surf-forecast__logo--clear.svg": 1093,
	"./logos/surf-forecast__logo--icon.svg": 1094,
	"./logos/surf-forecast__logo--white.svg": 1095,
	"./logos/surf-forecast__logo.svg": 1096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1022;